<script lang="ts" setup>
import { useCtaComponent } from '@monogrid/vue-boost'
import { PropType, useAttrs, useSlots } from 'vue'

import { IconOptions, SizeOptions } from '@/types'

import AppIcon from './AppIcon.vue'

defineProps({
  active: { type: Boolean, default: false },
  icon: { type: String as PropType<IconOptions>, required: true },
  size: { type: String as PropType<SizeOptions>, default: 'xs' }
})

const { bindings, component } = useCtaComponent({
  attrs: useAttrs(),
  emit: undefined,
  slots: useSlots(),
  expose: undefined
})
</script>

<template>
  <component
    :is="component"
    v-bind="bindings"
    :class="[{ active }, size, `icon-${icon}`]"
    :target="bindings.href ? '_blank' : undefined"
    class="app-button-icon relative inline-flex items-center justify-center"
    tabindex="0"
  >
    <AppIcon :icon="icon" :size="size" />
  </component>
</template>

<style lang="scss" scoped>
.app-button-icon {
  transition: color $default-duration ease, opacity $default-duration ease;

  ::v-deep(svg circle) {
    transition: fill $default-duration ease;
  }

  @include hover {
    &:hover {
      color: color('black');

      ::v-deep(svg circle) {
        fill: color('white');
      }
    }

    &.icon-cross {
      transition: transform $default-duration ease;

      &:hover {
        transform: rotate(180deg);
      }
    }
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }

  &.active {
    color: color('black');

    ::v-deep(svg circle) {
      fill: color('white');
    }
  }

  &.xs {
    font-size: rem(16px);
  }

  &.sm {
    font-size: rem(18px);
  }

  &.md {
    font-size: rem(24px);
  }

  &.lg {
    font-size: rem(34px);
  }
}
</style>
